export const downloadPDF = (blob, eventId) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `Invoice-${eventId}.pdf`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
